import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import UserForm from "./userComponents/UserForm";

import {
  useDetailUserQuery,
  useUpdateUserMutation,
} from "store/services/userApi";

import { useAppMeta } from "hooks";

const UserEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    {
      title: "Users",
      path: "/app/crm/user/list",
    },
    { title: "Edit User" },
  ];

  // RTK Query
  const {
    data: userDetail,
    isLoading: loadingUserDetail,
    error,
  } = useDetailUserQuery(id);

  const [updateUser, { isLoading: updatingUser }] = useUpdateUserMutation();

  //  methods
  const handleUpdateUser = async (data) => {
    try {
      await updateUser({ id, ...data }).unwrap();
      toast.success("User successfully updated!");
      navigate(`/app/crm/user/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update user!"
      );
    }
  };

  useAppMeta("Edit User");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingUserDetail || updatingUser}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <UserForm
          isBusy={loadingUserDetail || updatingUser}
          userDetail={userDetail}
          onSubmit={handleUpdateUser}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default UserEditScreen;
